/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import Vue from 'vue';
import store from '../../js/front/store';
import revealDirective from './directives/reveal';
import legalTocDirective from './directives/legal-toc';
import { initLandingAnalytics } from './analytics/landing';
import VueRouter from 'vue-router';
import * as rules from 'vee-validate/dist/rules';
import { extend } from 'vee-validate';
import Lang from 'lang.js';
import Inputmask from 'inputmask';
import ZiggyRoute from 'ziggy';
import { Ziggy } from '../../js/front/ziggy';

window.zRoute = (name, params) => ZiggyRoute(name, params, false, Ziggy);

window._ = require('lodash');

// Nothing here imports jQuery, but front.layouts.layout runs an inline
// $(document).ready(...) block at the bottom of the page.
window.$ = window.jQuery = require('jquery');

// Needed by the blade pages, not the SPA: profile/show opens #profileDemoLoginModal
// through $(el).modal().
window.Popper = require('popper.js').default;
require('bootstrap');

// install rules and localization
Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule]);
});

const default_locale = window.default_locale;
const fallback_locale = window.fallback_locale;
const messages = window.messages;

Vue.prototype.trans = new Lang({
  messages,
  locale: default_locale,
  fallback: fallback_locale
});

// load global config
Vue.prototype.globals = window.globals;

// VeeValidate translations
// loadLocale(default_locale);




/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

/**
 * Regex from http://detectmobilebrowsers.com/
 */
const isMobile = (function (a) {
  return (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) ? true : false;
})(navigator.userAgent || navigator.vendor || window.opera);

window.appVersionCode = 196;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.headers.common['Accept'] = 'application/json';
window.axios.defaults.headers.common['Platform'] = isMobile ? 'mobile' : 'pc';
window.axios.defaults.headers.common['Version-Code'] = window.appVersionCode;


/**
 * UUID for VUE APP request;
 */
let uuid = document.head.querySelector('meta[name="uuid"]');
if (uuid) {
  window.axios.defaults.headers.common['X-UUID-TOKEN'] = uuid.content;
}

const router = require('./router.js').default;

Vue.use(VueRouter);

Vue.component('app', require('./views/App.vue').default);
Vue.component('global-component', require('./components/GlobalComponent.vue').default);
Vue.component('login-modal-component', require('./components/LoginModal.vue').default);
Vue.component('register-modal-component', require('./components/RegisterModal.vue').default);
Vue.component('restore-account-modal-component', require('./components/RestoreAccountModal.vue').default);
Vue.component('cookie-banner-component', require('./components/CookieBanner.vue').default);
Vue.component('withdrawal-form-component', require('./components/WithdrawalForm.vue').default);
Vue.component('toast-host-component', require('./components/ToastHost.vue').default);

Vue.component('csae-page', require('./views/pages/CsaePage.vue').default);

// PaymentCatalystModal masks its card/expiry/CVC inputs with v-input-mask.
Vue.directive('input-mask', {
  bind: function (el) {
    new Inputmask().mask(el);
  },
});

Vue.directive('reveal', revealDirective);
Vue.directive('legal-toc', legalTocDirective);


/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const MOBILE_BREAKPOINT = 900;
const SCROLL_THRESHOLD = 24;

window.vApp = new Vue({
  el: '#app',
  store,
  router,
  data: {
    // Mobile burger menu open state.
    menuOpen: false,
    // Condensed header once the page is scrolled away from the top.
    scrolled: false,
  },
  mounted: function () {
    this.initNav();
    initLandingAnalytics();
  },
  methods: {
    initNav: function () {
      const self = this;

      const onScroll = function () {
        self.scrolled = window.scrollY > SCROLL_THRESHOLD;
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();

      window.addEventListener('resize', function () {
        if (window.innerWidth > MOBILE_BREAKPOINT) {
          self.menuOpen = false;
        }
      });

      window.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          self.menuOpen = false;
        }
      });
    },
    openCookieSettings: function () {
      if (typeof window.__vibelaShowCookieBanner === 'function') {
        window.__vibelaShowCookieBanner();
      }
    },
    afterUserLoaded: function (userId) {

    }
  },
  created() {
    this.$store.dispatch('user/load');
  }
});

